import { lazy } from 'react';

const LoadableBannedUserModal = lazy(
  () => import(/* webpackChunkName: "damz-modals" */ './BannedUserModal')
);

export default LoadableBannedUserModal;
